import { StylesQuery } from '../../FormSteps/Styles/StylesInput'
import { FacilitiesQuery } from '../../../Views/FormSteps/Facilities/FacilitiesInput.generated'
import ListItem from '../Base/SummaryList/Item/ListItem'
import BaseSummaryList from '../Base/SummaryList'
import useBriefContext from '../../../Hooks/Brief/useBriefContext'
import isDirectEnquiryBrief from '../../../Logic/Form/Sequences/DirectEnquiry/isDirectEnquiryBrief'
import EditLink from '../Base/SummaryList/EditLink'
import { formatLayout, formatTimings, formatBudget } from '../Base/Utilities/format'
import './SummaryList.less'

interface BizSummaryListProps {
  features?: FacilitiesQuery['collection']['features']
  styles?: StylesQuery['getAllStyles']
}

const BizSummaryList = ({ features, styles }: BizSummaryListProps): JSX.Element => {
  const { brief } = useBriefContext()
  const selectedFeatures = features
    ? brief.spaceFacilityIds?.map(
        (selectedID) => features.find(({ id }) => selectedID === parseInt(id, 10))?.name
      )
    : undefined
  const selectedStyles = styles
    ? brief.styleIds?.map((selectedID) => styles.find(({ id }) => id === selectedID)?.label)
    : undefined

  return (
    <BaseSummaryList
      className='biz-summary'
      heading={
        <>
          <h2>
            <span className='visually-hidden'>Your Event Summary: </span>
            {brief.eventName}
          </h2>
          <EditLink path={'name'} sectionLabel='event name' />
        </>
      }>
      <ListItem path='location' label='Location' editable={!isDirectEnquiryBrief(brief)}>
        {`${brief.location} + ${brief.radius}km`}
      </ListItem>

      <ListItem path='type' label='Event type'>
        {brief.collectionName ?? ''}
      </ListItem>

      <ListItem path='guests' label='Guests'>
        {brief.capacities}
      </ListItem>

      <ListItem path='style' label='Venue styles'>
        {selectedStyles ? selectedStyles.join(', ') || 'None' : '...'}
      </ListItem>

      <ListItem path='layout' label='Layout'>
        {formatLayout(brief)}
      </ListItem>

      <ListItem path='timings' label='Date & time'>
        {formatTimings(brief)}
      </ListItem>

      <ListItem path='flexible' label='Date flexibility'>
        {brief.flexibleDates ? 'Yes' : 'No'}
      </ListItem>

      <ListItem
        path='flexible'
        elementID='flexible-dates-notes'
        label='Flexibility note'
        show={brief.flexibleDates ?? undefined}>
        {brief.flexibleDatesNote ? `"${brief.flexibleDatesNote}"` : 'None'}
      </ListItem>

      <ListItem path='extras' label='Facilities'>
        {selectedFeatures ? selectedFeatures.join(', ') || 'None' : '...'}
      </ListItem>

      <ListItem path='extras' elementID='catering-needs' label='Food/drink requests'>
        {brief.cateringNeeds ? `"${brief.cateringNeeds}"` : 'None'}
      </ListItem>

      <ListItem path='budget' label='Budget'>
        {formatBudget(brief)}
      </ListItem>
    </BaseSummaryList>
  )
}

export default BizSummaryList
